import LoadContent from "components/LoadContent";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import "swiper/css";
import { Navigation } from "swiper/modules";
import { getStoriesRequest } from "./slice/getStoriesSlice";
// import "./Stories.css";
import useVideoPlayer from "./components/Reels/hooks/useVideoPlayer";
import useShowReels from "./components/Reels/hooks/useShowReels";
import './StoriesList.css'
import ReelsSlider from "./components/Reels/ReelSlider/ReelsSlider";
import ReelsModal from "./components/Reels/ReelsModal/ReelsModal";

export const Stories = () => {
  const dispatch = useDispatch();
  const { get_stories, imagesPath, loading, stories_title } = useSelector(
    (state) => state.getStoriesSlice
  );
  const { currentLanguage } = useSelector(({ main }) => main);

  useEffect(() => {
    dispatch(getStoriesRequest());
  }, [dispatch]);

  const {
    videoRefs,
    mutedMap,
    playingMap,
    toggleMute,
    togglePlayPause,
    registerVideoRef,
    setPlayingMap,
    setMutedMap,
  } = useVideoPlayer();

  const {
    isOpen,
    handleOpenSlider,
    handleCloseSlider,
    initialSlideIndex,
    handleSlideChange,
    swiperRef,
  } = useShowReels({ videoRefs, setPlayingMap, setMutedMap, get_stories });

  const memoizedCircles = useMemo(() => {
    if (loading) return Array.from({ length: 20 }).map((_, ind) => (
      <LoadContent containerClassName="ReelsLoader" key={ind} />
    ))

    return get_stories?.map((item) => (
      <div
        key={item.id}
        className="reels-circle-container"
        onClick={() => handleOpenSlider(item.id)}
      >
        <div className="reels-circle">
          <img
            src={`${imagesPath}/${item.main_photo}`}
            alt={item.title_en}
            className="reels-circle-img"
          />
        </div>
        <p className="reels-circle-title">
          {item["title_" + currentLanguage]}
        </p>
      </div>
    ));
  }, [get_stories, handleOpenSlider, loading, currentLanguage, imagesPath]);

  return (
    <div className="wrapper">
      <h3 className={"title"}>{stories_title[`title_${currentLanguage}`]}</h3>
      <div className="reels-scroll">{memoizedCircles}</div>

      
      <ReelsModal isOpen={isOpen} handleSlideChange={handleSlideChange}>
        <ReelsSlider
          stories={get_stories}
          mutedMap={mutedMap}
          playingMap={playingMap}
          toggleMute={toggleMute}
          togglePlayPause={togglePlayPause}
          registerVideoRef={registerVideoRef}
          setPlayingMap={setPlayingMap}
          handleCloseSlider={handleCloseSlider}
          initialSlideIndex={initialSlideIndex}
          handleSlideChange={handleSlideChange}
          swiperRef={swiperRef}
          imagesPath={imagesPath}
          loading={loading}
        />
      </ReelsModal>
    </div>
  );
};


// const handleStoryClick = (index) => {
//   setSelectedStoryIndex(index);
//   setIsOpen(true);
//   handleFullScreenToggle();
// };

//  {windowWidth < 768 ? (
//         <div className="stories__list">
//           {loading ? (
//             <div className="stories__wrapper scrollRow">
//               {Array.from({ length: 9 }).map((_, ind) => (
//                 <LoadContent containerClassName={"StoryLoader"} key={ind} />
//               ))}
//             </div>
//           ) : (
//             <div className="stories__wrapper scrollRow">
//               {get_stories.slice(0, 16)?.map((item, index) => {
//                 if (loadedStories.indexOf(index) > -1) {
//                   return (
//                     <SwiperSlide
//                       key={index}
//                       onClick={() => handleStoryClick(index)}
//                     >
//                       <div>
//                         <img src={imagesPath + "/" + item.main_photo} alt="" />
//                       </div>
//                       <p className={"StoriesTitle"}>
//                         {item["title_" + currentLanguage]}
//                       </p>
//                     </SwiperSlide>
//                   );
//                 } else {
//                   return (
//                     <SwiperSlide
//                       key={index}
//                       onClick={() => handleStoryClick(index)}
//                     >
//                       <LoadContent containerClassName={"StoryLoader"} />
//                     </SwiperSlide>
//                   );
//                 }
//               })}
//             </div>
//           )}
//         </div>
//       ) : (
//         <Swiper
//           navigation={windowWidth > 425 ? true : false}
//           slidesPerView={"auto"}
//           spaceBetween={windowWidth > 425 ? 30 : 20}
//           modules={[Navigation]}
//           loop={false}
//           className="stories__wrapper"
//         >
//           {loading ? (
//             <div
//               style={{
//                 display: "flex",
//                 gap: windowWidth > 425 ? 30 : 20,
//               }}
//             >
//               {Array.from({ length: 9 }).map((_, ind) => (
//                 <LoadContent containerClassName={"StoryLoader"} key={ind} />
//               ))}
//             </div>
//           ) : (
//             get_stories.slice(0, 16)?.map((item, index) => {
//               if (loadedStories.indexOf(index) > -1) {
//                 return (
//                   <SwiperSlide
//                     key={index}
//                     onClick={() => handleStoryClick(index)}
//                   >
//                     <div>
//                       <img src={imagesPath + "/" + item.main_photo} alt="" />
//                     </div>
//                     <p className={"StoriesTitle"}>
//                       {item["title_" + currentLanguage]}
//                     </p>
//                   </SwiperSlide>
//                 );
//               } else {
//                 return (
//                   <SwiperSlide
//                     key={index}
//                     onClick={() => handleStoryClick(index)}
//                   >
//                     <LoadContent containerClassName={"StoryLoader"} />
//                   </SwiperSlide>
//                 );
//               }
//             })
//           )}
//         </Swiper>
//       )}